"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("./utils");
function obfuscateEmail(email) {
    const [username, domain] = email.split("@");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", { dangerouslySetInnerHTML: {
                __html: `
          a>span.roe::after {
            content: "@";
          }
        `,
            } }),
        username,
        react_1.default.createElement("span", { className: "roe" }),
        domain));
}
function Email(_a) {
    var { bcc = [], body = "", cc = [], children, email, subject = "" } = _a, props = __rest(_a, ["bcc", "body", "cc", "children", "email", "subject"]);
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const emailUrl = new URL(`mailto:${email}`);
    emailUrl.search = (0, utils_1.percentEncodeParams)({ bcc, body, cc, subject });
    function handleHover() {
        setHovered(true);
    }
    const displayText = children || email;
    const obfuscatedText = children || obfuscateEmail(email);
    return (react_1.default.createElement("a", Object.assign({ href: hovered ? emailUrl.href : "#", onFocus: handleHover, onMouseOver: handleHover }, props), hovered ? displayText : obfuscatedText));
}
exports.Email = Email;
